import { Component, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { PreguntasService } from '../_services/preguntas.service';
import { NormasService } from '../_services/normas.service';
import { EmpresasService } from '../_services/empresas.service';
import { EvidenciasService } from '../_services/evidencias.service';

import { DropdownPregunta } from '../_models/preguntabase-dropdown.model';

import { UsuariosService } from '../_services/usuarios.service';

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";

import {ConfirmDialogModule,ConfirmationService} from 'primeng/primeng';

declare var jQuery:any;

@Component({
  selector: 'equipos',
  templateUrl: 'equipos.template.html',
})
export class EquiposComponent  implements OnInit, OnDestroy {

  questions: any[];
  formulario: string;
  subscription: Subscription;
  listaequipos: any[];
  equiposeleccionado: number = 0;
  detalleequipo: boolean = true;
  formequipo: boolean = false;

  iconocerrar: string = 'fa fa-times';
  iconoexpandir: string = 'fa fa-expand';

  puedoeditarequipo: boolean = true;

  filterQuery: string = "";

  constructor(private router:Router,
              private seguridad: SeguridadService,
              private normasService: NormasService,
              private globalEventsManager: GlobalEventsManager,
              private elementRef:ElementRef,
              private usuariosService : UsuariosService,
              private confirmationService: ConfirmationService,
              private evidenciasService: EvidenciasService,
              private empresasService: EmpresasService,
              private activatedRoute: ActivatedRoute){
    //this.questions = service.getQuestions();


  }

  ngOnInit(){

    this.globalEventsManager.menuExtendido(true);

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              //console.log("ET: "+mode);
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });

    this.getListaEquipos();
    this.actualizarBreadcrumb();


  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }


  getListaEquipos(){
    console.log("voy a recuperar los equipos");
    //this.normasService.getListaNormas();
    this.empresasService.getListaEquipos().subscribe(
      data => {
        console.log(data.json().lista);
        this.listaequipos = data.json().lista;
      }
    );
  }

  actualizarBreadcrumb(){
    let breadcrumb: any = [];

    let item = {
      'path':'#',
      'name': 'Edición de Equipos'
    };
    breadcrumb.push(item);

    this.globalEventsManager.setNombrePagina(breadcrumb);
  }

  cargarEquipo(id){

    this.equiposeleccionado = id;

    this.formulario = "";
    this.formulario = "mostrar";

  }

  verEquipo(id){
    //this.formulario = "";
    //
    this.formequipo = true;
    this.detalleequipo = false;

    this.equiposeleccionado = +id;

    this.puedoeditarequipo = true;

    this.cargarEquipo(id);

    //this.router.navigateByUrl('/capturadenormas/' +id );
  }

  editarEquipo(id_instalacion:number){
    this.formequipo = true;
    this.detalleequipo = false;

    this.equiposeleccionado = id_instalacion;
    this.puedoeditarequipo = true;
    this.cargarEquipo(id_instalacion);
  }

  nuevoEquipo(){
    this.editarEquipo(0);
  }


  stripText(val: string){
   var cadena: string = "";

   if (val != null){
     if (val.length>25){
       cadena = val.substr(0, 25)+"...";
     }else{
       cadena = val;
     }
   }

   return cadena;
  }

  expandir(nivel:number){
   if (nivel == 1){
     (this.detalleequipo) ? this.detalleequipo = false : this.detalleequipo = true;
   }
  }

  borrarInstalacion(id_equipo: number){
   this.empresasService.deleteEquipo(id_equipo).subscribe(
     data => {
       if (data){
         this.cerrar(1);
         this.getListaEquipos();
       }
     }
   );
  }

  confirmEquipo(id_equipo: number) {
     this.confirmationService.confirm({
         message: '¿Seguro que deseas eliminar la instalación?',
         accept: () => {
             this.borrarInstalacion(id_equipo);
         }
     });
  }

  onChangeEquipo(event){
   if(event){
     this.cerrar(1);
     this.getListaEquipos();
   }
  }

  onCloseEquipo(event: number){
   this.cerrar(1);
  }

  cerrar(nivel:number){

   //le pasamos el nivel al que tiene que ir
   if (nivel <= 1){
     this.equiposeleccionado = 0;
     this.detalleequipo = true;
     this.formequipo = false;
   }


   this.actualizarBreadcrumb();
  }

  scrollLienzo(){

   jQuery(".wrap-app").animate({scrollLeft: 5000}, 1000);
  }


}



// WEBPACK FOOTER //
// ./src/app/equipos/equipos.component.ts